import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PdfAndImageService {
  constructor() { }

  
  public getBase64AsBlob(data: string, contentType: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  public getBlobUrl(base64Data: string, contentType: string): Observable<string> {
    const blob = this.getBase64AsBlob(base64Data, contentType);
    const blobUrl = URL.createObjectURL(blob);
    return of(blobUrl);
  }

  public view(data: any, contentType: string) {
    let url;
    this.getBlobUrl(data, contentType).subscribe((blobUrl) => {
      url = blobUrl;
    });

    if (url) {
      window.open(url, '_blank');
    }
  }

  public download(data: any, contentType: string, fileName: string) {
    const blob = this.b64toBlob(data, contentType);
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    const fileType = contentType.split('/');
    a.download = String(fileName + (fileType[1] ? '.' + fileType[1] : ''));
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  public print(data: any, contentType: string) {
    const blob = this.b64toBlob(data, contentType);
    const url = window.URL.createObjectURL(blob);
    const printWindow = window.open(url, '_blank');
    if (printWindow) {
      printWindow.onload = function () {
        printWindow?.print();
      };
    }
  }

  private b64toBlob(b64Data: any, contentType: any) {
    contentType = contentType || '';
    const sliceSize = 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}